import axios from 'axios';
import { API_URL, getAuthConfig } from './api';

const handle = (error) => {
  if (error.response) {
    console.error('Quiz API error:', error.response.status, error.response.data);
  } else {
    console.error('Quiz API error:', error.message);
  }
};

// Список активных тестов (+ прогресс текущего пользователя)
export const APIGetQuizzes = async (token, { onboarding = false, category = null, availability = false } = {}) => {
  try {
    const params = new URLSearchParams();
    if (availability) params.set('availability', 'true');
    if (onboarding) params.set('onboarding', 'true');
    if (category) params.set('category', category);
    const qs = params.toString();
    const response = await axios.get(
      `${API_URL}/api/quizzes/${qs ? `?${qs}` : ''}`,
      getAuthConfig(token)
    );
    return response.data; // { quizzes: [...] } or { has_available_quizzes: boolean }
  } catch (error) { handle(error); throw error; }
};

// Детали теста (вопросы + мои ответы)
export const APIGetQuizDetail = async (token, code) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/quizzes/${code}/`,
      getAuthConfig(token)
    );
    return response.data;
  } catch (error) { handle(error); throw error; }
};

// Сохранить/финализировать ответы
export const APISubmitQuiz = async (token, code, { answers, isFinal = false } = {}) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/quizzes/${code}/submit/`,
      { answers, is_final: isFinal },
      getAuthConfig(token)
    );
    return response.data; // { saved, progress, is_completed, missing_required }
  } catch (error) { handle(error); throw error; }
};

// Мои результаты по всем тестам
export const APIGetMyQuizResults = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/quizzes/my-results/`,
      getAuthConfig(token)
    );
    return response.data; // { results: [...] }
  } catch (error) { handle(error); throw error; }
};


// Совместимость с конкретной анкетой + разбивка по параметрам
export const APIGetProfileCompatibility = async (token, profileId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/profiles/${profileId}/compatibility/`,
      getAuthConfig(token)
    );
    return response.data; // { profile_id, compatibility, breakdown: [...] }
  } catch (error) { handle(error); throw error; }
};